import { getTimelineValue } from '@/components/common/Filter/TimelineFilter/utils'
import {
    CustomReportFiltersParams,
    GetActiveManagementRequestParams,
    IntervalDataTypeParam,
} from '@/hooks'

export const processIntervalDataFilters = (
    filters: CustomReportFiltersParams
): GetActiveManagementRequestParams => {
    const { startDate, endDate } =
        'startDate' in filters && 'endDate' in filters
            ? { startDate: filters.startDate, endDate: filters.endDate }
            : getTimelineValue(filters.timeline)

    const result = {
        'nodeIds[]': filters.nodeIds.length
            ? filters.nodeIds.join(',')
            : undefined,
        'tagIds[]': filters.tagIds?.length
            ? filters.tagIds.join(',')
            : undefined,
        'facilityIds[]': filters.facilityIds?.length
            ? filters.facilityIds.join(',')
            : undefined,
        'usnAccountIds[]': filters.usnAccountIds?.length
            ? filters.usnAccountIds.join(',')
            : undefined,
        'meterIds[]': filters.meterIds?.length
            ? filters.meterIds.join(',')
            : undefined,
        'subMeterIds[]': filters.subMeterIds?.length
            ? filters.subMeterIds.join(',')
            : undefined,
        startDate,
        endDate,
        type: filters.type as IntervalDataTypeParam,
        timezone: filters.timezone,
        dataType: filters.dataType,
        dataGrouping: filters.dataGrouping,
        timeInterval: filters.timeInterval,
    }

    return result
}
